<template>
  <div>
    <b-row v-if="!showUpdate" align-v="center" class="pt-2">
      <b-col md="auto">
        <div>
          <BaseELabel
            :class="$style.labelSubHeading"
            label="Participant Information"
          />
        </div>
      </b-col>
      <b-col class="border-bottom"></b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col md="3">
        <BaseELabel mark-required label="Role" />
        <BaseDropdown
          v-model="participantRole"
          v-validate="{ required: true }"
          name="participantRole"
          type="text"
          data-vv-as="Role"
          :options="participantList"
          mark-required
          :class="$style.dropOptionstyle"
          :is-disabled="showUpdate"
          :show-select-as-option="'NO'"
          @change="checkValidation"
        ></BaseDropdown>
        <div class="error">
          {{ errors.first('participantRole') }}
        </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          id="participantType"
          v-model="participantType"
          data-vv-as="Participant Type"
          type="text"
          name="participantType"
          label-content=" Type"
          is-disabled
        ></BaseEInputText>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="3">
        <BaseEInputText
          id="participantFirstName"
          v-model="participantFirstName"
          v-validate="{ required: individualTypeValidation, max: 50, regex: /^[A-Za-z0-9.'#@%/ -]+$/ }"
          validattor="^[A-Za-z0-9.'#@%/ -]+$"
          data-vv-as="First Name"
          type="text"
          name="participantFirstName"
          label-content="First Name"
          :mark-required="individualTypeValidation"
          :placeholder="placeholders.firstName"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('participantFirstName') }}
        </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          id="participantMiddleName"
          v-model="participantMiddleName"
          v-validate="{ max: 50, regex: /^[A-Za-z0-9.'#@%/ -]+$/ }"
          validattor="^[A-Za-z0-9.'#@%/ -]+$"
          data-vv-as="Middle Name"
          type="text"
          name="participantMiddleName"
          label-content="Middle Name"
          :placeholder="placeholders.middleName"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('participantMiddleName') }}
        </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          id="participantLastName"
          v-model="participantLastName"
          v-validate="{ required: individualTypeValidation, max: 50, regex: /^[A-Za-z0-9.'#@%/ -]+$/ }"
          validattor="^[A-Za-z0-9.'#@%/ -]+$"
          data-vv-as="Last Name"
          max-length="50"
          type="text"
          name="participantLastName"
          label-content="Last Name"
          :mark-required="individualTypeValidation"
          :placeholder="placeholders.lastName"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('participantLastName') }}
        </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          id="participantLicense"
          v-model="participantLicense"
          v-validate="{ max: 50 }"
          type="text"
          name="participantLicense"
          label-content=" License Number"
          :placeholder="placeholders.participantLicense"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('participantLicense') }}
        </div>
      </b-col>
    </b-row>
    <b-row class="mb-3">
      <b-col md="3">
        <BaseEInputText
          id="participantCompany"
          v-model="participantCompany"
          v-validate="{ required: companyTypeValidation, max: 50, regex: /^[A-Za-z0-9.'#@%/ -]+$/ }"
          validattor="^[A-Za-z0-9.'#@%/ -]+$"
          type="text"
          name="participantCompany"
          label-content="Company Name"
          data-vv-as="Company Name"
          :mark-required="companyTypeValidation"
          :placeholder="placeholders.participantCompany"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('participantCompany') }}
        </div>
      </b-col>
      <b-col md="3">
        <BaseELabel :mark-required="stateFieldValidate" label="State" />
        <BaseDropdown
          v-model="participantState"
          v-validate="{ required: stateFieldValidate }"
          data-vv-as="State"
          :field-id="participantState"
          :options="states"
          name="participantState"
          :placeholder="placeholders.state"
        ></BaseDropdown>
        <div class="error"> {{ errors.first('participantState') }} </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          id="participantZip"
          v-model="participantZip"
          validattor="[0-9]"
          type="text"
          maxlength="5"
          name="participantZip"
          label-content="Zip"
          :placeholder="placeholders.participantZip"
        ></BaseEInputText>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          id="participantPhoneNumber"
          v-model="participantPhoneNumber"
          v-validate="{
            regex: /^\(\d{3}\)\s*\d{3}(?:-|\s*)\d{4}$/,
          }"
          validattor="[0-9]"
          maskker="(\d{3})(\d{3})(\d{4})"
          formatter="($1) $2-$3"
          type="text"
          maxlength="14"
          name="participantPhoneNumber"
          label-content="Phone"
          data-vv-as="Phone Number"
          :placeholder="placeholders.phoneNumber"
        ></BaseEInputText>
        <div class="error">
          {{ errors.first('participantPhoneNumber') }}
        </div>
      </b-col>
    </b-row>
    <b-row v-if="!showUpdate">
      <b-col md="12" class="mt-3 mb-1">
        <BaseEButton
          id="addNotesTooltip"
          class="d-inline-block float-right mb-1 px-3"
          variant="icon"
          @click="addParticipantData"
          >New <BaseIcon name="plus" class="ml-1"> </BaseIcon></BaseEButton
        ><b-tooltip target="addNotesTooltip" triggers="hover">
          {{ 'Add Participant' }}
        </b-tooltip>
      </b-col>
    </b-row>
    <b-row v-if="showUpdate" class="float-right py-2">
      <b-col>
        <BaseEButton variant="cancel" @click="confirmCancelClicked">
          Cancel</BaseEButton
        >
        <BaseEButton @click="updateRecord">
          Update
        </BaseEButton>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  props: {
    editRequestData: {
      type: Object,
      default: () => {},
    },
    updateMode: {
      type: Boolean,
      default: false,
    },
    roleOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      individualTypeValidation: false,
      companyTypeValidation: false,
      stateValidation: false,
      participantRole: '',
      participantType: '',
      participantFirstName: '',
      participantMiddleName: '',
      participantLastName: '',
      participantLicense: '',
      participantCompany: '',
      participantState: '',
      participantZip: '',
      participantPhoneNumber: '',
      participantRecordIndex: '',
      participantList: [],
    }
  },
  computed: {
    placeholders() {
      return {
        firstName: 'First Name',
        middleName: 'Middle Name',
        lastName: 'Last Name',
        state: 'Select State',
        phoneNumber: '(xxx) xxx-xxxx',
        participantLicense: 'Participant License',
        participantCompany: 'Company Name',
        participantZip: 'xxxxx',
      }
    },
    states() {
      return this.$_allStates
    },
    editData() {
      return this.editRequestData.item
    },
    showUpdate() {
      return this.updateMode
    },
    stateFieldValidate() {
      return this.stateValidation || this.companyTypeValidation
    },
    participantRoles() {
      return this.roleOptions
    },
  },
  mounted() {
    if (this.participantRoles.length) {
      this.participantRoles.forEach((item) => {
        this.participantList.push({
          text: item.role,
          value: item.role,
        })
      })
    }
    if (this.showUpdate && this.editData) {
      this.participantRole = this.editData.Role
      this.participantType = this.editData.Type
      this.participantFirstName = this.editData.FirstName
      this.participantMiddleName = this.editData.MiddleName
      this.participantLastName = this.editData.LastName
      this.participantLicense = this.editData.LicenseNumber
      this.participantCompany = this.editData.CompanyName
      let getstateCode = this.editData.State ? this.editData.State : null
      let stateObj = this.states.find((st) => st.stateCode === getstateCode)
      this.participantState = stateObj ? stateObj.value : null
      this.participantZip = this.editData.Zip
      this.participantPhoneNumber = this.editData.Phone
      switch (this.participantType) {
        case 'Individual':
          this.individualTypeValidation = true
          this.stateValidation = this.participantRole === 'Appraiser'
          break
        case 'Company':
          this.companyTypeValidation = true
          break
      }
    }
  },
  methods: {
    checkValidation() {
      let typeOfParticipant = this.participantRoles.filter(
        (x) => x.role === this.participantRole
      )
      this.participantType = typeOfParticipant[0].type
      this.individualTypeValidation = this.participantType === 'Individual'
      this.stateValidation = this.individualTypeValidation
        ? this.participantRole === 'Appraiser'
        : false
      this.companyTypeValidation = this.participantType === 'Company'
    },
    addParticipantData() {
      this.$validator.validate().then((response) => {
        if (response) {
          let stateObj = this.states.find(
            (st) => st.value === Number(this.participantState)
          )
          this.$emit('addParticipantData', {
            participantRole: this.participantRole,
            participantType: this.participantType,
            participantFirstName: this.participantFirstName,
            participantMiddleName: this.participantMiddleName,
            participantLastName: this.participantLastName,
            participantLicense: this.participantLicense,
            participantCompany: this.participantCompany,
            State: stateObj ? stateObj.stateCode : null,
            StateName: stateObj ? stateObj.text : null,
            participantZip: this.participantZip,
            participantPhoneNumber: this.participantPhoneNumber,
          })
          this.clearParticipantData()
        }
      })
    },
    clearParticipantData() {
      this.participantFirstName = ''
      this.participantLastName = ''
      this.participantLicense = ''
      this.participantCompany = ''
      this.participantState = ''
      this.participantMiddleName = ''
      this.participantZip = ''
      this.participantPhoneNumber = ''
      this.$validator.reset()
    },
    confirmCancelClicked() {
      this.$emit('confirmCancelClicked')
    },
    updateRecord() {
      this.$validator.validate().then((response) => {
        if (response) {
          let stateObj = this.states.find(
            (st) => st.value === Number(this.participantState)
          )
          let UpdateRequestObject = {
            participantRecordIndex: this.editRequestData.index,
            ParticipantsOrders: {
              Role: this.participantRole,
              Type: this.participantType,
              FirstName: this.participantFirstName,
              MiddleName: this.participantMiddleName,
              LastName: this.participantLastName,
              LicenseNumber: this.participantLicense,
              CompanyName: this.participantCompany,
              State: stateObj ? stateObj.stateCode : null,
              StateName: stateObj ? stateObj.text : null,
              Zip: this.participantZip,
              Phone: this.participantPhoneNumber,
            },
          }
          this.$emit('updateParticipantRecord', {
            UpdateRequestObject,
          })
        }
      })
    },
  },
}
</script>
<style lang="scss" module>
@import '@design';

.labelSubHeading {
  margin-left: -2rem;
  font-size: $size-content-font;
  font-weight: 500;
  color: $color-text-gray;
}
</style>
